import { accountsTotalSpendAndEmsSelector } from "./accountsTotalSpendAndEmsSelector";
import { RootState } from "../../../store";

export const accountEmsByAccountIdSelector = (
  state: RootState,
  accountId: string,
) => {
  const data = accountsTotalSpendAndEmsSelector(state);

  return data?.[accountId]?.ems;
};
